import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { useStore } from 'hooks/useStore';
import { TSubscribedFilter } from 'store/Subscriptions/SubscribedFilter';

import css from './Counters.module.css';

interface ICounters {
  filter: TSubscribedFilter;
}

const Counters = ({ filter }: ICounters) => {
  const {
    app: { i18n },
  } = useStore();

  if (!filter.instance?.hasValidCounters || !filter.counters) return null;

  const { hasNewLoads, hasUpdatedLoads } = filter.counters;

  return (
    <span className={css.counters}>
      {hasNewLoads && <span className={cn(css.counter, css.counter_new)}>{i18n.subscriptions.newLoads}</span>}

      {hasUpdatedLoads && (
        <span className={cn(css.counter, css.counter_updated)}>{i18n.subscriptions.newChangedLoads}</span>
      )}
    </span>
  );
};

const connected = observer(Counters);

export { connected as Counters };
